import React from 'react';

export type Props = {
  className?: string;
  color?: string;
  height?: number;
  onClick?(): void;
  width?: number;
};

const clipId = 'check_icon_clipId';

export const Check = React.memo((props: Props) => {
  const {
    width = 24,
    height = 24,
    className,
    color = '#0F0A1B',
    onClick,
  } = props;

  const style = {
    minWidth: width,
    minHeight: height,
  };

  return (
    <svg
      width={width}
      height={height}
      className={className}
      onClick={onClick}
      style={style}
      viewBox={`0 0 ${width} ${height}`}
      fill='none'
    >
      <g clipPath={`url(#${clipId})`}>
        <path d='M20.5563 6.82767L10.6569 16.7272L5 11.0703' stroke={color} strokeWidth='3' strokeLinecap='round' strokeLinejoin='round' />
      </g>
      <defs>
        <clipPath id={clipId}>
          <rect width={width} height={height} fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
});

Check.displayName = 'Check';
